import React from 'react';
import { useTranslation } from 'react-i18next';
import { getVisitsFinancialSummaryChartLabels } from '../../../common/Charts';
import BarChart from '../../../components/BarChart';
import ErrorMessage from '../../../components/ErrorMessage';
import PiChartWidgetSkeleton from '../../../components/skeletons/PiChartWidgetSkeleton';
import { IServiceResponse } from '../../../hooks/HookService';
import { IEmployeesFinancialReports } from '../../../interfaces/Reports';

const VisitQuantityReportSummaryWidget = ({
  data,
  error,
  errorMessage,
  isLoading,
}: IServiceResponse<IEmployeesFinancialReports>) => {
  const { t } = useTranslation();
  if (isLoading) {
    return <PiChartWidgetSkeleton />;
  }
  if (error || !data) {
    return <ErrorMessage error={errorMessage} />;
  }

  const visitsCountData = [
    {
      name: t('financialReports.employees.totalCount'),
      data: [data?.totalPendingVisits || 0, data?.totalDoneVisits || 0, data?.totalVisits || 0],
    },
  ];

  return (
    <BarChart
      title={t('global.dashboard.visitsQuantitySummary')}
      chartCategories={getVisitsFinancialSummaryChartLabels(t)}
      chartData={visitsCountData}
    />
  );
};

export default VisitQuantityReportSummaryWidget;
